import { NeoModel, ModelBase } from '@singularsystems/neo-core';
@NeoModel
export default class StaticOrganisationLookup extends ModelBase {

    public organisationId: number = 0;

    public nominatedCurrencyId: number = 0;

    public organisationName: string = "";
}